export interface IArchivo {
  url: string;
}

export class Archivo {
  url: string;

  constructor(data: IArchivo) {
    this.url = data.url;
  }

}
